module.exports = __webpack_public_path__ + "media/images/web/header_home-89dfa126a9716f517df3089598b62e14.png";